import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';


const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 16,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export default function CustomizedMenus(props) {
    var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
    var selectedCourse = localStorage.getItem('etlSelectCourse'); 
    var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
    var deviceType = localStorage.getItem('deviceType');
    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [organisationList, setOrganisationList] = React.useState([]);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [loader, setLoader] = React.useState(false);
    const [newIndex, setNewIndex] = React.useState(0);
  
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function switchCourse(index){
        if(selectedIndex!==index){
          if(loader===false){    
            window.localStorage.setItem("etlSelectCourse", index);
            setNewIndex(index);
          }
          setLoader(true);
          
          let axiosHeader = {
            headers:{
              'Content-Type': 'multipart/mixed',
              'loginId': etlStudentObj.loginId,
              'token': etlStudentObj.token,
              'device': 'web'
            }
          };

          const data = new FormData();
                data.append('openedCourseIndex', index);
                axios.post(API_URL+'/lastopenedcourse', data, axiosHeader)
                .then((response) => { 
                  setLoader(false);
            if(response.data.responseTxt==="success"){ 

                window.location.href='dashboard';							

              // if(mySelectedCourses[index].templateId && mySelectedCourses[index].templateId>0){
                //   getApiDataLastOpenedCourseUpdate(mySelectedCourses[index].templateId);
                // }
            }  
          })
          .catch((error) => {
            console.log("AXIOS ERROR: ", error);
          })
    
        }
      }
    
    //   async function getApiDataLastOpenedCourseUpdate(templateId){
    //     axios.get(API_URL+'/templatecache?templateId='+templateId)
    //        .then(response => {
    //        ///console.log("Just Checking >> "+response.data);  
    //       if(response && response.data && response.data.responseTxt==="success"){

    //           if(response.data.topicList && response.data.topicList.length>0){
    //             window.localStorage.setItem("etlTopicList", response.data.topicList);
    //           }else{
    //             window.localStorage.setItem("etlTopicList", "");
    //           }
    //           if(response.data.keywordList && response.data.keywordList.length>0){
    //             window.localStorage.setItem("etlKeywordList", response.data.keywordList);
    //           }else{
    //             window.localStorage.setItem("etlKeywordList", "");
    //           }
    //           if(response.data.topicTree && response.data.topicTree.length>0){
    //             window.localStorage.setItem("etlTopicTree", response.data.topicTree);
    //           }else{
    //             window.localStorage.setItem("etlTopicTree", "");
    //           }
    //           if(response.data.topicTreeLearning && response.data.topicTreeLearning.length>0){
    //             window.localStorage.setItem("etlTopicTreeLearning", response.data.topicTreeLearning);
    //           }else{
    //             window.localStorage.setItem("etlTopicTreeLearning", "");
    //           }
    //           if(response.data.topicListLearning && response.data.topicListLearning.length>0){
    //             window.localStorage.setItem("etlTopicListLearning", response.data.topicListLearning);
    //           }else{
    //             window.localStorage.setItem("etlTopicListLearning", "");
    //           }
    //           if(response.data.keywordListLearning && response.data.keywordListLearning.length>0){
    //             window.localStorage.setItem("etlKeywordListLearning", response.data.keywordListLearning);
    //           }else{
    //             window.localStorage.setItem("etlKeywordListLearning", "");
    //           }
    //           if(response.data.topicTreeTest && response.data.topicTreeTest.length>0){
    //             window.localStorage.setItem("etlTopicTreeTest", response.data.topicTreeTest);
    //           }else{
    //             window.localStorage.setItem("etlTopicTreeTest", "");
    //           }
    //           if(response.data.topicListTest && response.data.topicListTest.length>0){
    //             window.localStorage.setItem("etlTopicListTest", response.data.topicListTest);
    //           }else{
    //             window.localStorage.setItem("etlTopicListTest", "");
    //           }
    //           // if(response.data.smartLearningJson && response.data.smartLearningJson.length>0){
    //           //   window.localStorage.setItem("etlSmartLearning", response.data.smartLearningJson);
    //           // }else{
    //             window.localStorage.setItem("etlSmartLearning", "");
    //           // }
    //           if(response.data.mockTestJson && response.data.mockTestJson.length>0){
    //             window.localStorage.setItem("etlMockTest", response.data.mockTestJson);
    //           }else{
    //             window.localStorage.setItem("etlMockTest", "");
    //           }
      
    //           const mydtmout = setTimeout(
    //             function () {
    //               setLoader(false);
    //               clearTimeout(mydtmout);
    //               window.location.href='dashboard';							
    //             }
    //           , 6000);
    
    //       } 
    
    //     })
    //  }
    
    React.useEffect(() => {
        if(selectedCourse!==null && selectedCourse>=0 && mySelectedCourses!==null && mySelectedCourses[0]!==null){
            setOrganisationList(mySelectedCourses);
            setSelectedIndex(selectedCourse);
        }
    }, []); 

    function goToLocation(url){
       window.location=url;
    }

    function validTillDateFormat(val,stype,corseTitle){    
        let rtrn = '';
        if(val && stype && stype.indexOf("FREE")<0){
          let valArr = val.split("-");
          let myDate = valArr[2]+'-'+valArr[1]+'-'+valArr[0];
          rtrn = stype+', '+myDate;
        }else if(stype==='FREEFOREVER' || (stype==='FREE' && corseTitle.indexOf("FREE FOREVER")>-1)){
          rtrn = 'FREE';  
        }else{
          rtrn = 'FREE TRIAL';
        }
        return rtrn;
    }
    
    function upgrade(corseDate,stype,corseTitle){
      let rtrn = 1;
      if(stype==='FREEFOREVER' || (stype==='FREE' && corseTitle.indexOf("FREE FOREVER")>-1)){
        rtrn = 0;
      }else if(stype.indexOf("FREE")===-1 && corseTitle.indexOf("FREE FOREVER")===-1){
        let d1 = new Date();
        let d2 = new Date(corseDate);
        d2.setDate(d2.getDate() + 1);
        if(d1>d2){
          rtrn = 2;
        }else{
          rtrn = 0;
        }  
      }
      return rtrn;
    }
  
    function goToCourseBuy(cid){
        window.location.href='selectcourse?cid='+cid;
    }
        

  return (
    <div>      
      <Button
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}        
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        color="inherit"
        title='Click for other courses'
        className='headCorsName'
      >
        {props.title}
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >

        {(organisationList && organisationList.length>0)?organisationList.map((myRow,index)=>(          
          (index===selectedIndex)?
          <MenuItem disableRipple key={'lib'+index} onClick={()=>{switchCourse(index)}} sx={{backgroundColor:'#c2e4fc',color:'#1f407a'}}>
            <ListItemIcon>{(loader && newIndex===index)?<CircularProgress size={25} />:<RadioButtonCheckedIcon />}</ListItemIcon>
            <ListItemText primary={<div onClick={()=>{switchCourse(index)}} className="corstitle" >{myRow.organisationName}</div>} secondary={<div><div>{validTillDateFormat(myRow.validTillDate,myRow.packTypeTitle,myRow.organisationName)}</div><div>{(deviceType && deviceType!=='ios' && upgrade(myRow.validTillDate,myRow.packTypeTitle,myRow.organisationName)>0)?<Button onClick={()=>{goToCourseBuy(myRow.courseId)}} style={{textTransform:'none',height:20,backgroundColor:'#008140',color:'#FFF'}} size='small' variant='contained' >{(upgrade(myRow.validTillDate,myRow.packTypeTitle,myRow.organisationName)===2)?<>Renew</>:<>Upgrade</>}</Button>:null}</div></div>}  />
          </MenuItem>
          :
          <MenuItem disableRipple key={'lib'+index} onClick={()=>{switchCourse(index)}} >
            <ListItemIcon>{(loader && newIndex===index)?<CircularProgress size={25} />:<RadioButtonUncheckedIcon />}</ListItemIcon>
            <ListItemText primary={<div onClick={()=>{switchCourse(index)}} className="corstitle" >{myRow.organisationName}</div>} secondary={<div><div>{validTillDateFormat(myRow.validTillDate,myRow.packTypeTitle,myRow.organisationName)}</div><div>{(deviceType && deviceType!=='ios' && upgrade(myRow.validTillDate,myRow.packTypeTitle,myRow.organisationName)>0)?<Button onClick={()=>{goToCourseBuy(myRow.courseId)}} style={{textTransform:'none',height:20,backgroundColor:'#008140',color:'#FFF'}} size='small' variant='contained' >{(upgrade(myRow.validTillDate,myRow.packTypeTitle,myRow.organisationName)===2)?<>Renew</>:<>Upgrade</>}</Button>:null}</div></div>} />
          </MenuItem>
        )):null}

        {(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].otherCourses===1)?
        <MenuItem onClick={()=>{goToLocation('selectcourse')}} style={{width:275}} disableRipple>
          <AutoAwesomeIcon />
          Other Courses
        </MenuItem>
        :null}


      </StyledMenu>
    </div>
  );
}
